@if (isDeleteVisible === true) {
  @if (!isAddCateringDialogVisible) {
    <div class="row" style="float: right;padding-right: 26px;padding-top: 10px;">
      <button (click)="addNewCateringMenuClicked()" mat-raised-button>Add Catering Menu</button>
    </div>
  }
  @if (isAddCateringDialogVisible) {
    <div style="display:flex;justify-content: center;">
      <mat-card>
        <mat-card-header>
          <mat-card-title>Catering menu</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div>
            <div class="field">
              <div class="field-label">Title</div>
              <div class="field-value">
                <input [(ngModel)]="cateringMenu.title" [ngClass]="{'error-border': cateringMenuError.title === true}"
                  style="width: 320px;" type="text">
              </div>
            </div>
            <div class="field">
              <div class="field-label">
                Show Description <input [(ngModel)]="cateringMenu.showDescription" style="width: 32px;"
                type="checkbox">
              </div>
              <div class="field-label">Description</div>
              <div class="field-value">
                <textarea [(ngModel)]="cateringMenu.description"
                style="width: 320px;height: 100px;"></textarea>
              </div>
            </div>
            <div class="field">
              <div class="field-label">Items</div>
              <div (click)="addCateringMenuItem()" (keyup.enter)="addCateringMenuItem()" tabindex="0" role="button" class="field-label"
                style="float: right; margin-top: -22px; cursor: pointer">(+)
              </div>
              @for (item of cateringMenu.items; track item; let i = $index) {
                <div class="field-value">
                  <input (change)="onValueChange($event, i)" [ngClass]="{'error-border': cateringMenuError.items === true}"
                    [value]="cateringMenu.items[i]"
                    style="width: 310px;" type="text">
                  @if (i>0) {
                    <div (click)="removeCateringMenuItem(i)" (keyup.enter)="removeCateringMenuItem(i)" tabindex="0" role="button" class="field-label"
                      style="float: right;  cursor: pointer">(-)
                    </div>
                  }
                </div>
              }
            </div>
            <div class="field">
              <div class="field-label">Qty</div>
              <div class="field-value">
                <input [(ngModel)]="cateringMenu.qty" [ngClass]="{'error-border': cateringMenuError.qty === true}"
                  style="width: 320px;" type="text">
              </div>
            </div>
            <div class="field">
              <div class="field-label">Price</div>
              <div class="field-value">
                <input [(ngModel)]="cateringMenu.price" [ngClass]="{'error-border': cateringMenuError.price === true}"
                  style="width: 320px;" type="text">
              </div>
            </div>
            <div class="field">
              <div class="field-label"></div>
              <div class="field-value">
                IsVisible <input [(ngModel)]="cateringMenu.isVisible" style="width: 32px;" type="checkbox">
              </div>
            </div>
          </div>
          @if (cateringMenuError.touched && cateringMenuError.isInvalid) {
            <div class="row"
              style="color: red; font-size: 10px;margin-left: 20px;">
              *Please correct the above error(s)
            </div>
          }
          @if (!hasAnyEditButtonClicked()) {
            <div class="row" style="justify-content: center;">
              <button (click)="addCateringMenu()" mat-raised-button>Add</button>
              <button (click)="cancelCateringMenu()" mat-raised-button>Cancel</button>
            </div>
          }
        </mat-card-content>
      </mat-card>
    </div>
  }
  <div style="margin-top: 85px"></div>
}

<div class="wrapper">
  @for (m of cateringMenuItems; track m) {
    <div>
      <div class="menu-card">
        @if (isDeleteVisible === true) {
<div style="cursor:pointer;float: right; margin-top: -53px;border: 2px solid greenyellow;
    padding: 2px;">
            <div style="color:black; font-size: 16px;">
              <input (change)="updateCateringMenuItem(m)" [(ngModel)]="m.isVisible" type="checkbox">
              <div (click)="deleteCateringMenu(m)" (keyup.enter)="deleteCateringMenu(m)" tabindex="0" role="button" style="color:red; font-size: 16px; float: right; padding-left: 10px;">
                Delete(x)
              </div>
              @if (!m.isEditButtonClicked) {
                <div (click)="editButtonClicked(m)" (keyup.enter)="editButtonClicked(m)" tabindex="0" role="button"
                  style="font-size: 16px; float: right; padding-left: 10px;">
                  Edit
                </div>
              }
              @if (m.isEditButtonClicked) {
                <div style="font-size: 16px; float: right; padding-left: 10px;">
                  <span (click)="updateCateringMenu(m)" (keyup.enter)="updateCateringMenu(m)" tabindex="0" role="button">Save/</span>
                  <span (click)="cancelUpdate(m)" (keyup.enter)="cancelUpdate(m)" tabindex="0" role="button">Cancel</span>
                </div>
              }
            </div>
          </div>
        }
        <div class="menu-box">
          <div class="menu-text">
            <div class="menu-title"> {{m.title}} </div>
            <div class="menu-price">${{m.price}}</div>
          </div>
          <div class="menu-description"> {{m.description}}</div>
          <br/>
          @for (item of m.items; track item) {
            <div class="menu-description">
              <span class="item-type">{{getItemType(item)}}: </span>
              <span>{{getItemDescription(item)}}</span>
              &nbsp;
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>

